import { useFieldArray, useFormContext } from "react-hook-form";
import InputWithLabel from "../InputWithLabel";
import { FullRegistrationFormType } from "../../schemas/XFlowFullRegSchema";
import Dropdown from "../DropDown";
import { currencyOptions } from "../../constants/xFlow";

export default function BankDetails() {
  const {
    register,
    formState: { errors },
    control,
  } = useFormContext<FullRegistrationFormType>();

  const { fields, append, remove } = useFieldArray({
    control,
    name: "bank_details",
  });

  return (
    <div className="space-y-10">
      {fields.map((field, index) => (
        <div key={field.id} className="grid grid-cols-2 gap-4">
          <div className="col-span-full flex items-center gap-2">
            {/* <h3 className="font-medium text-[#344054]">Bank {index + 1}</h3> */}
            {index > 0 && (
              <button
                type="button"
                className="text-sm text-red-500"
                onClick={() => remove(index)}
              >
                Remove
              </button>
            )}
          </div>

          <InputWithLabel
            label="Account Reference Name"
            placeholder="Enter here"
            {...register(`bank_details.${index}.account_ref_name`)}
            error={errors.bank_details?.[index]?.account_ref_name?.message}
          />

          <InputWithLabel
            label="Account Holder Name"
            placeholder="Enter here"
            {...register(`bank_details.${index}.account_holder_name`)}
            error={errors.bank_details?.[index]?.account_holder_name?.message}
          />

          <InputWithLabel
            label="Bank Name"
            placeholder="Enter here"
            {...register(`bank_details.${index}.bank_name`)}
            error={errors.bank_details?.[index]?.bank_name?.message}
          />

          <InputWithLabel
            label="Account Number"
            placeholder="Enter here"
            {...register(`bank_details.${index}.account_number`)}
            error={errors.bank_details?.[index]?.account_number?.message}
          />

          <InputWithLabel
            label="SWIFT / IFSC"
            placeholder="Enter here"
            {...register(`bank_details.${index}.swift_ifsc`)}
            error={errors.bank_details?.[index]?.swift_ifsc?.message}
          />

          <Dropdown
            label="Currency"
            placeholder="Select a currency e.g. USD"
            options={currencyOptions}
            {...register(`bank_details.${index}.currency`)}
            error={errors.bank_details?.[index]?.currency?.message}
          />

          <hr className="col-span-full" />

          <h2 className="col-span-full font-medium text-[#344054]">
            Bank Address
          </h2>

          <div className="col-span-full">
            <InputWithLabel
              label="Address"
              placeholder="Enter here"
              {...register(`bank_details.${index}.address`)}
              error={errors.bank_details?.[index]?.address?.message}
            />
          </div>

          <InputWithLabel
            label="City"
            placeholder="Enter here"
            {...register(`bank_details.${index}.city`)}
            error={errors.bank_details?.[index]?.city?.message}
          />

          <InputWithLabel
            label="State"
            placeholder="Enter here"
            {...register(`bank_details.${index}.state`)}
            error={errors.bank_details?.[index]?.state?.message}
          />

          <InputWithLabel
            label="Postal Code"
            placeholder="Enter here"
            {...register(`bank_details.${index}.postal_code`)}
            error={errors.bank_details?.[index]?.postal_code?.message}
          />

          <InputWithLabel
            label="Country"
            placeholder="Enter 2-letter country code (e.g. IN)"
            {...register(`bank_details.${index}.country`)}
            error={errors.bank_details?.[index]?.country?.message}
          />

          {/* <InputWithLabel
            label="Global Wire"
            placeholder="Enter here"
            {...register(`bank_details.${index}.global_wire`)}
            error={errors.bank_details?.[index]?.global_wire?.message}
          /> */}

          {/* <InputWithLabel
            label="Category"
            placeholder="Enter category"
            {...register(`bank_details.${index}.category`)}
            error={errors.bank_details?.[index]?.category?.message}
          /> */}

          {/* <InputWithLabel
            label="Upload File"
            type="file"
            // {...register(`bank_details.${index}.file`)}
            // error={errors.bank_details?.[index]?.file?.message}
          /> */}
        </div>
      ))}

      {/* Button to add another bank detail */}
      {/* <button
        type="button"
        className="bg-blue-800 text-white px-4 py-2 rounded-md"
        onClick={() =>
          append({
            account_ref_name: "",
            account_holder_name: "",
            bank_name: "",
            account_number: "",
            swift_ifsc: "",
            currency: "",
            address: "",
            postal_code: "",
            city: "",
            state: "",
            country: "",
            // global_wire: "",
            category: "user_payout",
            // file: undefined,
          })
        }
      >
        + Add Another Bank
      </button> */}
    </div>
  );
}
